export enum StaticFilterValues {
  PRODUCT_ID = "productid"
}

export const FIELD_EVENTS = {
  LOAD_DATA: '_loadData',
  SEARCH: '_search'
} as const;

export const SEARCH_CONFIG = {
  DEBOUNCE_DELAY: 500,
  MIN_SEARCH_LENGTH: 3
} as const;

export const DIMENSION_NAME_PRODUCT = 'productDimension';
export const SEPARATOR_HYPHEN = " - ";

export enum ProductDimension {
  PRODUCT = 'Product',
  ALTPRODUCT = 'AltProduct'
}

export interface DimensionsList {
  productDimension?: string;
}
